import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './auth.css';

const EmailVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const verifyEmail = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link.');
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      try {
        // The backend endpoint handles verification and redirects
        // This component is for displaying status if needed
        setStatus('success');
        setMessage('Email verified. Continue to payment.');
        
        // The backend will redirect to payment page
        // This is a fallback in case JavaScript redirect is needed
        setTimeout(() => {
          const email = params.get('email');
          if (email) {
            navigate(`/payment?verified=1&email=${encodeURIComponent(email)}`);
          } else {
            navigate('/login?verified=1');
          }
        }, 2000);
      } catch (err) {
        setStatus('error');
        setMessage('Email verification failed. Please try again.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    verifyEmail();
  }, [location, navigate]);

  return (
    <div className="auth-wrapper">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <h1>Email Verification</h1>
        
        <div style={{
          padding: '20px',
          marginTop: '20px',
          borderRadius: '8px',
          background: status === 'error' ? 'rgba(239, 68, 68, 0.1)' : 
                     status === 'success' ? 'rgba(34, 197, 94, 0.1)' : 
                     'rgba(96, 165, 250, 0.1)',
          border: `1px solid ${status === 'error' ? 'rgba(239, 68, 68, 0.3)' : 
                               status === 'success' ? 'rgba(34, 197, 94, 0.3)' : 
                               'rgba(96, 165, 250, 0.3)'}`
        }}>
          {status === 'verifying' && (
            <div>
              <div className="spinner" style={{ 
                margin: '0 auto 16px',
                width: '40px',
                height: '40px',
                border: '4px solid rgba(96, 165, 250, 0.2)',
                borderTop: '4px solid #60a5fa',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
              <p style={{ color: '#60a5fa', fontSize: '16px', margin: 0 }}>{message}</p>
            </div>
          )}
          
          {status === 'success' && (
            <div>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>✓</div>
              <p style={{ color: '#22c55e', fontSize: '16px', fontWeight: '600', margin: 0 }}>{message}</p>
            </div>
          )}
          
          {status === 'error' && (
            <div>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>✗</div>
              <p style={{ color: '#ef4444', fontSize: '16px', fontWeight: '600', margin: 0 }}>{message}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
